<template>
  <div class="main-text">
    <div class="hello">尊敬的用户：</div>
    <div class="main-content">
      使用紫光云控制台需要安装Internet Explorer更新版本的浏览器，
      请下载
      <a
        href="http://windows.microsoft.com/zh-cn/internet-explorer/download-ie"
        style="color: #4875f6;"
      >安装IE10</a>
      （或更新），也可以在其他浏览器，如
      <a href="http://www.google.com/intl/zh-CN/chrome/" style="color: #4875f6;">Chrome</a>
      或
      <a href="http://www.firefox.com.cn/download/" style="color: #4875f6;">Firefox火狐</a>中打开控制台。
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageList: {},
      defaultList: {
        title: "紫光云",
        meta: [
          {
            hid: "meta标签ID，建议使用随机生成ID，不能重复",
            name: "meat标签的name属性，用于SEO优化",
            content: "meat标签的content属性，用于SEO优化"
          }
        ],
        list: [
          {
            block_id: "自定义组件ID，系统随机生成",
            block_type: "browserCompatibility",
            block_data: {
              title: "您的浏览器不兼容我们的版本",
              version: {
                subTitle: "浏览器兼容的版本如下：",
                versionList: [
                  {
                    version: "Chrome版本：>=41"
                  },
                  {
                    version: "FireFox版本：>=41"
                  },
                  {
                    version: "Opera版本：>=41"
                  },
                  {
                    version: "Safari版本：>=9"
                  },
                  {
                    version: "UC版本：>=6"
                  },
                  {
                    version: "Edge版本：>=0.3.3"
                  }
                ]
              },
              description: {
                descTitle: "说明：",
                descList: [
                  {
                    text: "IE浏览器目前不支持"
                  },
                  {
                    text: "当提示浏览器版本升级时，可以看到如下提示"
                  }
                ]
              }
            }
          }
        ]
      }
    };
  },
  head() {
    return {
      title: this.defaultList.title,
      meta: this.defaultList.meta
    };
  }
};
</script>

<style scoped>
.main-text a {
  text-decoration: underline !important;
}
.main-text {
  margin: 130px auto 70px auto;
  background-color: #fdf0e6 !important;
  border: 1px solid #ec670b;
  width: 1170px;
  text-align: left;
  font-size: 14px;
  font-family: "STHeiti Light";
  color: #ec670b;
  padding: 20px 40px 20px 40px;
}

.hello {
  padding-top: 50px;
  padding-left: 127px;
}

.main-content {
  padding-right: 125px;
  padding-bottom: 65px;
  padding-left: 125px;
}
</style>
